module.exports = __webpack_public_path__ + "img/Rank-default.b95587d4.png";